<template>
    <div class="paginator">
        <ul>
            <li><span @click="toggleList()"><i class="icon icon-icon_thumbnail"></i></span></li>
            <li v-bind:class="{hidden:internalValue.page==1}" class="previous"><span @click="previous()"><i class="icon icon-icon_arrow-left"></i></span></li>
            <li><span>Page {{internalValue.page}} / {{internalValue.last}}</span></li>
            <li v-bind:class="{hidden:internalValue.page==internalValue.last}" class="next"><span @click="next()"><i class="icon icon-icon_arrow-right"></i></span></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Paginator',
        props: ['value'],
        data: function () {
            return {
                internalValue: {}
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            previous: function () {
                this.internalValue.page = this.internalValue.page-1 > 0 ? this.internalValue.page-1 : 1
                this.$emit('input', this.internalValue);
                this.$emit('refresh')
                document.querySelector('#page-main .content-body').scrollTo(0,0)
            },
            next: function () {
                this.internalValue.page = this.internalValue.page+1 <= this.internalValue.last ? this.internalValue.page+1 : this.internalValue.last
                this.$emit('input', this.internalValue);
                this.$emit('refresh')
                document.querySelector('#page-main .content-body').scrollTo(0,0)
            },
            toggleList: function(){
                this.internalValue.listing = this.internalValue.listing ? "" : "thumbnail";
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Paginator.vue